import React from 'react';
import { Box, Container, Typography, Divider } from '@mui/material';

const Footer = () => {
  return (
    <Box sx={{ bgcolor: '#05192b', color: '#8d9da8', py: 4 }}>
      <Container maxWidth="lg">
        <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
          <Typography variant="h6" sx={{ color: 'white', fontWeight: 'bold' }}>Green & Blue Solutions</Typography>
          <Typography variant="body2">Environmental & Water Consultancy</Typography>
        </Box>
        <Divider sx={{ bgcolor: 'rgba(255,255,255,0.1)', my: 2 }} />
        <Typography variant="caption" display="block" align="center">
          © {new Date().getFullYear()} Green & Blue Solutions. All rights reserved.
        </Typography>
      </Container>
    </Box>
  );
};

export default Footer;